<template>
  <b-container fluid id="header" data-cy="header-container">
    <b-row
      class="shadow mol__header top-bar-color"
      :style="{ heigth: mobile ? 80 : 100, zIndex: 999 }"
      align-v="center"
      data-cy="header-row-principal"
    >
      <modal-user-login data-cy="modal-login"></modal-user-login>
      <modal-user-sign-up data-cy="modal-cadastro"></modal-user-sign-up>
      <modal-user-recover-password
        data-cy="modal-recuperar-senha"
      ></modal-user-recover-password>
      <b-col cols="auto" v-show="!mobile" data-cy="header-col-logo">
        <router-link
          :to="{
            name: 'index',
            params: { organizationId: $route.params.organizationId }
          }"
          data-cy="header-link-home"
        >
          <img
            :src="logoimage"
            v-show="logoimage"
            class="img-fluid"
            @error="placeholder"
            style="max-height: 4.5rem"
            data-cy="header-logo-image"
          />
        </router-link>
      </b-col>
      <b-col class="align-self-center" data-cy="header-col-titulo">
        <ul
          style="list-style: none; padding: 0"
          class="m-0"
          data-cy="header-lista-titulo"
        >
          <li data-cy="header-item-subtitulo">
            <small class="text-weight-bold" data-cy="header-texto-central"
              >Central de agendamento</small
            >
          </li>
          <li v-if="organization" data-cy="header-item-organizacao">
            <h6 data-cy="header-titulo-organizacao">
              <b data-cy="header-nome-organizacao" v-if="!clinic">
                {{ organization.nome }}
              </b>
              <div data-cy="header-nome-organizacao-clinica" v-else>
                <b data-cy="header-nome-organizacao-principal">{{
                  `${organization.nome}`
                }}</b
                ><br />
                <b data-cy="header-nome-clinica">{{ `${clinic.nome}` }}</b>
              </div>
            </h6>
          </li>
        </ul>
      </b-col>
      <b-col cols="auto" id="login-buttons" data-cy="header-col-acoes">
        <b-dropdown
          variant="white"
          :text="`${!mobile ? `Bem-vindo(a), ${user.nome.split(' ')[0]}` : ''}`"
          class="m-md-2"
          v-if="user !== null && user.nome !== null && !token"
          data-cy="dropdown-usuario-sem-token"
        >
          <b-dropdown-item @click="logoff" data-cy="dropdown-item-sair"
            >Sair</b-dropdown-item
          >
        </b-dropdown>
        <b-dropdown
          variant="white"
          toggle-class="top-text-color"
          :text="`${!mobile ? `Bem-vindo(a), ${user.nome.split(' ')[0]}` : ''}`"
          class="m-md-2"
          v-if="user !== null && user.nome !== null && token"
          data-cy="dropdown-usuario-logado"
          right
        >
          <b-dropdown-item
            :active="$route.name === 'index'"
            :to="{
              name: 'index',
              params: { organizationId: $route.params.organizationId }
            }"
            data-cy="dropdown-item-agendar"
          >
            Agendar
          </b-dropdown-item>
          <b-dropdown-item
            :active="$route.name === 'history'"
            :to="{
              name: 'history',
              params: { organizationId: $route.params.organizationId }
            }"
            data-cy="dropdown-item-historico"
          >
            Histórico de Agendamentos
          </b-dropdown-item>
          <b-dropdown-divider data-cy="dropdown-divisor"></b-dropdown-divider>
          <b-dropdown-item @click="logoff" data-cy="dropdown-item-sair-logado"
            >Sair</b-dropdown-item
          >
        </b-dropdown>
        <button
          :class="{ 'btn-lg': !mobile }"
          class="btn btn-outline-primary my-2 my-sm-0"
          v-if="!token"
          type="submit"
          @click.prevent="toLogin"
          data-cy="btn-login"
        >
          <font-awesome-icon
            size="lg"
            class="mr-lg-2"
            :icon="['far', 'user']"
            data-cy="btn-login-icon"
          />{{ !mobile ? "Login" : "" }}
        </button>
        <button
          :class="{ 'btn-lg': !mobile }"
          class="btn btn-primary my-2 my-sm-0 ml-4"
          v-if="!token"
          type="submit"
          @click.prevent="toSignUp"
          data-cy="btn-cadastro"
        >
          <font-awesome-icon
            size="lg"
            class="mr-lg-2"
            :icon="['far', 'user']"
            data-cy="btn-cadastro-icon"
          />
          {{ !mobile ? "Cadastre-se" : "" }}
        </button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ModalUserLogin from "@/components/modal-user-login.vue";
import ModalUserRecoverPassword from "@/components/modal-user-recuperar-senha.vue";
import ModalUserSignUp from "@/components/modal-user-signUp.vue";
import { axiosInstance as Axios } from "@/main";
import Store from "@/store";

export default {
  name: "mol-header",
  components: {
    ModalUserLogin,
    ModalUserSignUp,
    ModalUserRecoverPassword
  },
  data() {
    return {
      clinic: null
    };
  },
  mounted() {
    // carregar clinica específica
    if (this.clinicSpecific) {
      let clinic_id = this.$route.query.clinica;

      Axios.get(`${this.$serverHost}geral/clinicas/${clinic_id}`, {
        headers: { "X-Organizacao-ID": this.$route.params.organizationId }
      }).then(response => {
        this.clinic = response.data;
      });
    }
  },
  computed: {
    clinicSpecific() {
      return (
        this.$route.query.hasOwnProperty("c") &&
        this.$route.query.hasOwnProperty("clinica")
      );
    },
    logoimage() {
      return this.$store.getters.get_logoImage;
    },
    organization() {
      return this.$store.getters.get_organization;
    },
    actual() {
      return this.$store.getters.actual;
    },
    user() {
      return this.$store.getters.user;
    },
    mobile() {
      return this.$store.getters.width < 768;
    },
    token() {
      return this.$store.getters.token;
    }
  },
  methods: {
    placeholder(e) {
      e.target.src = require("../assets/images/clinic.png");
    },
    logoff() {
      this.$store.dispatch("logoff");
      this.$router.push(`/index/${this.$route.params.organizationId}`);
    },
    toLogin() {
      Store.dispatch("set_modalLogin", true);
    },
    toSignUp() {
      Store.dispatch("set_modalSignUp", true);
    },
    toRecoverPassword() {
      Store.dispatch("set_modalRecoverPassword", true);
    }
  }
};
</script>

<style scoped>
.row {
  height: 5rem;
}
</style>
